import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SessionService } from '../services/session/session.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private session: SessionService
  ) { }

  async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    const isAuthenticated = await this.session.getToken();

    if (isAuthenticated) {
      
      if (state.url.startsWith("/login")) {
        return this.router.createUrlTree(["contratos"]);
      }
      return true;
    }

    if (state.url.startsWith("/login")) {
      return true;
    }

    return this.router.createUrlTree(["login"]);

    
  }
}
